import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useUploadsProject } from 'hooks/useUploadsProject'
import { useFiles } from './useFiles'
import { filesKeys } from './filesKeys'

export const useUploadedFiles = () => {
  const workspaceId = useCurrentWorkspaceId()
  const uploadsProjectId = useUploadsProject(workspaceId).data?.project?.id

  const params = {
    q: {
      project_key_in: uploadsProjectId ? [uploadsProjectId] : [],
      s: 'created_at desc',
      asset_type_in: 'MediaFile',
    },
  }

  return useFiles(params, {
    queryKey: filesKeys.uploadsInfinite(workspaceId, params),
    enabled: Boolean(uploadsProjectId),
  })
}
